import React, { Component } from 'react';
import { Container, Card, Row, Col, Image, Button } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { GET } from '../../api';
import moment from 'moment';
import { Black, CerisePink, CyanProcess, White } from '../../helpers/brand_colors_helper';
import GetIcon from '../../helpers/icon_helper';
import { sendCloudMessage } from '../../helpers/cloud_message';
import { toast } from 'react-toastify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
class StudentAttendanceReport extends Component {
    state = {
        currentMonth: moment().format('YYYY-MM-DD'),
        getAbsenceData: [],
        centerCalendarData: [],
        isRefreshingCenterCalendarData: false,
    };


    componentDidMount() {
        // this.getAttendance()
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedChild } = this.props;
        if (prevProps.selectedChild.child_id !== selectedChild.child_id || prevProps.selectedChild.class_id !== selectedChild.class_id) {
            this.getAttendance()
        }
    }

    getAbsence = () => {
        if (this.getAbsenceRequest) {
            this.getAbsenceRequest.abort()
        }
        this.getAbsenceRequest = new AbortController();
        GET('authentication/get-absence', {
            params: {
            },
            signal: this.getAbsenceRequest.signal,
        }).then((res) => {
            // console.log('authentication/get-absence', res);
            if (res) {
                let resData = res.data
                this.setState({ getAbsenceData: resData })
            }
        })
    }

    getAttendance = () => {
        try {
            const { child_id, class_id } = this.props.selectedChild;
            this.setState({ isRefreshingCenterCalendarData: true })
            if (this.getAttendanceRequest) {
                this.getAttendanceRequest.abort();
            }
            this.getAttendanceRequest = new AbortController();
            GET('children/get-attendance', {
                params: {
                    class_id: class_id,
                    child_id: child_id,
                    startDate: moment(this.state.currentMonth).startOf('month').format('YYYY-MM-DD'),
                    endDate: moment(this.state.currentMonth).endOf('month').format('YYYY-MM-DD'),
                },
                signal: this.getAttendanceRequest.signal,
            }).then((res) => {
                // console.log('get-attendance', res);
                if (res) {
                    let resData = res.data
                    this.setState({
                        centerCalendarData: resData.map((v) => {
                            let backgroundColor = CyanProcess
                            if (v.absent) {
                                backgroundColor = CerisePink
                            }
                            let title = ''
                            if (v.absent) {
                                if (v.absence_name) {
                                    title = (v.absence_name).toUpperCase()
                                } else {
                                    title = 'ABSENT'
                                }
                            } else {
                                title = 'ATTENDED'
                            }
                            return { ...v, start: v.att_date, end: v.att_date, title: title, backgroundColor: backgroundColor }
                        }),
                        isRefreshingCenterCalendarData: false
                    });
                } else {
                    this.setState({ isRefreshingCenterCalendarData: false })
                }
            })
        } catch (e) {
            console.log('eeeee', e);

        }
    }


    pushAbsenceNotification = () => {
        if (this.state.markingAttendance) {
            return
        }
        this.setState({ markingAttendance: true }, () => {
            if (this.pushAbsenceNotificationReq) {
                this.pushAbsenceNotificationReq.abort()
            }
            this.pushAbsenceNotificationReq = new AbortController();
            let { class_id, child_id } = this.props.selectedChild
            GET('children/push-absence-notification', {
                params: {
                    child_id: child_id,
                    class_id: class_id,
                    att_date: moment().format('YYYY-MM-DD'),
                },
                signal: this.pushAbsenceNotificationReq.signal,
            }).then((res) => {
                // console.log('pushAbsenceNotificationReq', res);
                if (res) {
                    let resData = res.data
                    if (resData.type) {
                        resData.pushNotification.map((v, i) => {
                            sendCloudMessage(v.user_id, v.title, v.body, v.data)
                        })
                        toast[resData.messageType](resData.message);
                    }
                    this.setState({ markingAttendance: false })
                }
            }).catch((e) => {
                console.log('e', e);

            })
        })
    }

    render() {
        let { centerCalendarData, currentMonth } = this.state
        let totalPresent = 0
        let totalAbsent = 0
        centerCalendarData.map((v, i) => {
            if (v.absent == 1) {
                totalAbsent++
            } else {
                if (v.att_datetime_in != null) {
                    totalPresent++
                }
            }
        })


        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <NavBar />
                    <div id='page-content'>
                        <Header lite={true} heading={t('Attendance Report')} backBtn showChildSelector={true} />
                        <div>
                            <Button size='sm' variant='danger' onClick={() => this.pushAbsenceNotification()}>{t('Send Absence Notification')}</Button>
                        </div>
                        <div className='p-2' style={{ width: '100%' }}>
                            <FullCalendar
                                showNonCurrentDates={false}
                                height={'auto'}
                                headerToolbar={{
                                    left: "today prev,next",
                                    center: "title",
                                    right: "",
                                }}
                                plugins={[
                                    dayGridPlugin,
                                ]}
                                initialView='dayGridMonth'
                                events={centerCalendarData}
                                locale={'en'}
                                direction={'ltr'}
                                datesSet={(dateInfo) => { //INVOKE WHEN DATE SET CHANGED
                                    let dateStart = dateInfo.start
                                    let dateEnd = dateInfo.end
                                    this.setState({ currentMonth: moment(dateStart).format('YYYY-MM-DD') }, () => {
                                        this.getAttendance()
                                    })
                                }}
                            />
                        </div>
                        <div className='d-flex flex-row align-items-center justify-content-around mt-2' style={{ width: '100%' }}>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div style={{ fontWeight: 600 }}>Present</div>
                                <div className='badge badge-light-primary'>{totalPresent}</div>
                            </div>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div style={{ fontWeight: 600 }}>Absent</div>
                                <div className='badge badge-light-danger'>{totalAbsent}</div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            {React.Children.toArray(centerCalendarData.map((v, i) => {
                                if (v.att_datetime_in || v.att_datetime_out || parseInt(v.absent) != 0) {
                                    return <div key={i} className='d-flex flex-row justify-content-between align-items-center px-2 mb-2 border-bottom pb-1' style={{ width: '100%' }}>
                                        <div className='d-flex flex-column' style={{ flex: 1 }}>
                                            <div style={{ fontWeight: 600, color: Black }}>{moment(v.att_date).format('DD-MM-YYYY')}</div>
                                            <div style={{ fontWeight: 600, color: Black }}>{moment(v.att_date).format('dddd')}</div>
                                        </div>
                                        <div className='d-flex flex-row ps-2' style={{ flex: 1 }}>
                                            {(v.att_datetime_in)
                                                ? <div className='d-flex flex-row align-items-center'>
                                                    <Image src={require('../../assets/images/attendance-check-in.png')} style={{ resizeMode: 'contain', height: 50, width: 50 }} />
                                                    <div className='ms-1' style={{ fontWeight: 600, color: Black }}>{moment(v.att_datetime_in).format('hh:mm A')}</div>
                                                </div>
                                                : null}
                                            {(v.att_datetime_out)
                                                ? <div className='d-flex flex-row align-items-center'>
                                                    <Image src={require('../../assets/images/attendance-check-out.png')} style={{ resizeMode: 'contain', height: 50, width: 50 }} />
                                                    <div className='ms-1' style={{ fontWeight: 600, color: Black }}>{moment(v.att_datetime_out).format('hh:mm A')}</div>
                                                </div>
                                                : null}
                                            {(parseInt(v.absent) == 1)
                                                ? <div className='d-flex flex-row align-items-center'>
                                                    <Image src={require('../../assets/images/attendance-absent.png')} style={{ resizeMode: 'contain', height: 50, width: 50 }} />
                                                    <div className='ms-1' style={{ fontWeight: 600, color: Black }}>{(v.absence_name) ? v.absence_name : t('Absent')}</div>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                }
                                return null
                            }))}

                        </div>
                    </div>
                </div>
            </Container >
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(StudentAttendanceReport);
